import { useState } from 'react';
import { Eye, EyeOff } from 'lucide-react';
import { logoColor } from '../../ui/media';
import { useStore } from '@tanstack/react-store';
import { themeStore } from '../../../stores/theme';
import { useNavigate, useParams } from 'react-router-dom';
import { useResetPassword } from '../../../hooks/useAuth';
import toast from 'react-hot-toast';

// Main App Component
const ResetPassword = () => {
  const { email, otp } = useParams()
  const { isDarkMode } = useStore(themeStore)
  const [password, setPassword] = useState('');
  const [confPassword, setConfPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [showConfPassword, setShowConfPassword] = useState(false);
  const resetPasswordMutation = useResetPassword()
  const navigate = useNavigate()

  const handleResetPassword = () => {
    if(password == "" || confPassword == "") {
      toast.error("Password & Confirm Password is not allowed to empty")
      return
    }
    if(password !== confPassword) {
      toast.error("Password & Confirm Password should be same")
      return
    }
    resetPasswordMutation.mutate({ email: decodeURIComponent(email), new_password: password, otp }, {
      onSuccess: () => {
        toast.success("Password changed successfully")
          navigate(`/login`)
      },
      onError: (error) => {
          const message = error.response?.data?.message || "Server Error"
          toast.error(message)
      }
  })
  };

  const Logo = () => {
    return (
      <div className="flex flex-col items-center">
        <img src={logoColor} className='h-[70px]' />
      </div>
    );
  };

  return (
    <div className={`min-h-screen flex items-center justify-center p-4`}>
      <div className={`w-full max-w-md rounded-lg shadow-lg overflow-hidden ${isDarkMode ? 'bg-gray-800' : 'bg-white'}`}>
        <div className="bg-blue-100 w-[95%] mx-auto my-3 rounded-lg p-6 flex justify-center">
          <div className="flex flex-col items-center">
            <Logo />
          </div>
        </div>
        <h1 className={`text-2xl poppins-regular font-bold mt-4 text-center ${isDarkMode ? 'text-white' : 'text-gray-800'}`}>New Password</h1>
        <p className={`text-sm mt-2 text-center ${isDarkMode ? 'text-white' : 'text-gray-600'}`}>
          Please enter your new password.
        </p>
        {/* Reset Password Form */}
        <div className="p-6">
          <div className="mb-4">
            <div className="flex justify-between">
              <label className={`block text-sm font-medium mb-1 ${isDarkMode ? 'text-white' : 'text-gray-600'}`}>Password</label>
            </div>
            <div className="relative">
              <input
                placeholder='********'
                type={showPassword ? "text" : "password"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className={`w-full p-3 rounded border ${isDarkMode
                    ? 'bg-gray-700 border-gray-600 text-white'
                    : 'bg-white border-gray-300'
                  }`}
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                className="absolute inset-y-0 right-0 flex items-center pr-3">
                {showPassword ?
                  <EyeOff size={18} className="text-blue-600" /> :
                  <Eye size={18} className="text-blue-600" />
                }
              </button>
            </div>
          </div>
          <div className="mb-4">
            <div className="flex justify-between">
              <label className={`block text-sm font-medium mb-1 ${isDarkMode ? 'text-white' : 'text-gray-600'}`}>Confirm Password</label>
            </div>
            <div className="relative">
              <input
                placeholder='********'
                type={showConfPassword ? "text" : "password"}
                value={confPassword}
                onChange={(e) => setConfPassword(e.target.value)}
                className={`w-full p-3 rounded border ${isDarkMode
                    ? 'bg-gray-700 border-gray-600 text-white'
                    : 'bg-white border-gray-300'
                  }`}
              />
              <button
                type="button"
                onClick={() => setShowConfPassword(!showConfPassword)}
                className="absolute inset-y-0 right-0 flex items-center pr-3">
                {showPassword ?
                  <EyeOff size={18} className="text-blue-600" /> :
                  <Eye size={18} className="text-blue-600" />
                }
              </button>
            </div>
          </div>
          <div className='text-center'>
            <button
                onClick={handleResetPassword}
                disabled={resetPasswordMutation?.isLoading?true:false}
                className="w-[200px] poppins-regular bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-6 rounded-full text-center">
                { resetPasswordMutation?.isLoading? "Verifying..." : "Submit" }
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
export default ResetPassword